import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AggregationInfo_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', aggregationInfo: { __typename?: 'AssetAggregateAggregationInfo', fileCount: number, folderCount: number } };

export type AggregationInfo_Collection_Fragment = { __typename?: 'Collection', aggregationInfo: { __typename?: 'AssetAggregateAggregationInfo', fileCount: number, folderCount: number } };

export type AggregationInfo_CollectionShare_Fragment = { __typename?: 'CollectionShare', aggregationInfo: { __typename?: 'AssetAggregateAggregationInfo', fileCount: number, folderCount: number } };

export type AggregationInfoFragment = AggregationInfo_AdHocAssetsShare_Fragment | AggregationInfo_Collection_Fragment | AggregationInfo_CollectionShare_Fragment;

export const AggregationInfo = /*#__PURE__*/ gql`
    fragment AggregationInfo on AssetAggregate {
  aggregationInfo(folderId: $folderId) {
    fileCount
    folderCount
  }
}
    ` as unknown as DocumentNode<AggregationInfoFragment, unknown>;

        

        
export const useAggregationInfoFragment = (
  input: string | Omit<UseFragmentOptions<AggregationInfoFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AssetAggregate' } };
    return input;
  })();

  return useFragment<AggregationInfoFragment>({
    fragment: AggregationInfo,
    fragmentName: 'AggregationInfo',
    ...options,
  });
};
  
        